import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const userName = sessionStorage.getItem('user_name');

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/register");
  };

  return (
    <>
      {/* Secondary Bar */}
      <div className="secondary-bar mb-3">
        <div className="container">
          <div className="d-md-flex align-items-center justify-content-between">
            <Link to="/" className="mb-2 mt-4 wow animated fadeInLeft hide-mobile logoText">
              <h3>Florida <span>Driving</span> Permit</h3>
            </Link>
            {sessionStorage.getItem("user_id") ? (
              <div className="dropdown mt-3 hide-mobile">
                <button
                  className="btn btn-secondary dropdown-toggle text-start bg-transparent text-dark p-0 border-0"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span className="d-flex gap-3 align-items-center">
                    <i className="fa fa-user-circle opacity-50 mt-1"style={{fontSize: '2.5rem'}}></i>
                    <span>
                      {sessionStorage.getItem("user_name").trim() !== "null" ? sessionStorage.getItem("user_name").trim() : "User"}
                      <br />
                      <strong>{sessionStorage.getItem("user_email")}</strong>
                    </span>
                  </span>
                </button>
                <ul className="dropdown-menu mt-3 p-0 shadow-sm overflow-hidden">
                  <li>
                    <button
                      type="button"
                      className="dropdown-item p-3"
                      onClick={() => {
                        navigate("/profile-edit");
                      }}
                    >
                      <i className="fa fa-user me-2 text-primary-s"></i> Edit Profile
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="dropdown-item p-3"
                      data-bs-toggle="modal"
                      data-bs-target="#changePasswordModal"
                    >
                      <i className="fa fa-lock me-2 text-primary-s"></i> Change Password
                    </button>
                  </li>
                  <li>
                    <a className="dropdown-item p-3" onClick={handleLogout}>
                      <i className="fa fa-sign-out me-2 text-primary-s"></i> Logout
                    </a>
                  </li>
                </ul>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="navbar navbar-expand-lg bg-light-primary sticky-top w-100 z-3 wow animated fadeInDown border-bottom shadow-sm">
        <div className="container">
          <Link to="/" className="wow animated fadeInLeft hide-desktop logoText">
            <h3>Florida <span>Driving</span> Permit</h3>
          </Link>
          <div className="d-flex align-items-center">
            {/* Mobile-only profile dropdown (mirrors desktop menu) */}
            {sessionStorage.getItem("user_id") ? (
              <div className="dropdown me-2 d-lg-none">
                <button
                  className="btn btn-secondary dropdown-toggle text-start bg-transparent text-dark p-0 border-0"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span className="d-flex align-items-center">
                    <i className="fa fa-user-circle opacity-50 fa-2x"></i>
                  </span>
                </button>
                <ul className="dropdown-menu dropdown-menu-end mt-2 p-0 shadow-sm overflow-hidden">
                  <li>
                    <a
                      className="dropdown-item p-3"
                      href="javascript:;"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/profile-edit");
                      }}
                    >
                      <i className="fa fa-user me-2 text-primary-s"></i> Edit Profile
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item p-3"
                      href="javascript:;"
                      data-bs-toggle="modal"
                      data-bs-target="#changePasswordModal"
                    >
                      <i className="fa fa-lock me-2 text-primary-s"></i> Change Password
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item p-3" onClick={handleLogout}>
                      <i className="fa fa-sign-out me-2 text-primary-s"></i> Logout
                    </a>
                  </li>
                </ul>
              </div>
            ) : null}

            <button className="navbar-toggler btn btn-primary-s py-2 text-white" type="button" data-bs-toggle="collapse"
              data-bs-target="#mainNav" aria-controls="mainNav" aria-expanded="false" aria-label="Toggle navigation">
              <i className="fa fa-bars"></i>
            </button>
          </div>
          
          <div className="collapse navbar-collapse py-2" id="mainNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#features">Features</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#course">Our Course</a>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact-us">Contact Us</Link>
              </li>
            </ul>
            <form className="d-flex" role="search">
              {userName ? (
                <Link to="/course/home" className="btn btn-secondary-s rounded-start">Go To Dashboard</Link>
              ) : (
                <>
                  <Link to="/login" className="btn btn-secondary-s rounded-start me-3">Login</Link>
                  <Link to="/register" className="btn btn-secondary-s rounded-start">Register</Link>
                </>
              )}
            </form>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
